import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { PhonogramListStore } from "../../store/PhonogramListStore";

type PhonogramListDialogsProps = {
  store: PhonogramListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de Phonogram.
 * Separado para mantener PhonogramListPage más limpio.
 */
export const PhonogramListDialogs: React.FC<PhonogramListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
